import { Box, Typography, Backdrop } from '@mui/material';
import { Trans } from 'react-i18next';

const FileDropOverlay = () => (
  <Backdrop open={true} sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}>
    <Box
      sx={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Typography variant="h4" align="center" color="white">
        <Trans i18nKey="fileDrop.text"> Drop your .bps file to upload</Trans>
      </Typography>
    </Box>
  </Backdrop>
);

export default FileDropOverlay;
